import { Button, Col, Row } from "antd";
import { UserBubble } from "@shared/ui";
import { fallbackString, formatMoscowDatetime } from "@shared/utils";
import "./section-first-details.scss";

interface SectionFirstDetailsProps {
  currentItem: any;
}

export const SectionFirstDetails = ({
  currentItem,
}: SectionFirstDetailsProps) => {
  const fmt = (d?: string) => fallbackString(formatMoscowDatetime(d));

  const fio =
    `${currentItem?.userCompany?.user?.surname ?? ""} ${currentItem?.userCompany?.user?.firstName ?? ""} ${currentItem?.userCompany?.user?.middleName ?? ""}`.trim();

  return (
    <div className="section-first-details">
      <div className="section-first-details__section">
        <div className="section-first-details__title">
          Организация, осуществляющая строительство, реконструкцию, капитальный
          ремонт
        </div>
        <div className="section-first-details__value">
          {fallbackString(currentItem?.company?.fullName)}
        </div>
      </div>

      <div className="section-first-details__section">
        <div className="section-first-details__title">
          Лицо, входящее в список инженерно-технического персонала
        </div>

        <div className="section-first-details__table">
          <Row className="section-first-details__row">
            <Col span={8} className="section-first-details__label">
              ФИО
            </Col>
            <Col span={16} className="section-first-details__text">
              <UserBubble userId={currentItem?.userCompany?.user?.userId}>
                <Button type="link" style={{ padding: 0, height: "auto" }}>
                  {fallbackString(fio)}
                </Button>
              </UserBubble>
            </Col>
          </Row>

          <Row className="section-first-details__row">
            <Col span={8} className="section-first-details__label">
              Организация
            </Col>
            <Col span={16} className="section-first-details__text">
              {fallbackString(currentItem?.company?.fullName)}
            </Col>
          </Row>

          <Row className="section-first-details__row">
            <Col span={8} className="section-first-details__label">
              Должность
            </Col>
            <Col span={16} className="section-first-details__text">
              {fallbackString(currentItem?.userCompany?.user?.position)}
            </Col>
          </Row>

          <Row className="section-first-details__row">
            <Col span={8} className="section-first-details__label">
              Вид работ
            </Col>
            <Col span={16} className="section-first-details__text">
              {fallbackString(currentItem?.workType)}
            </Col>
          </Row>

          <Row className="section-first-details__row">
            <Col span={8} className="section-first-details__label">
              Дата начала работ
            </Col>
            <Col span={16} className="section-first-details__text">
              {fmt(currentItem?.dateStart)}
            </Col>
          </Row>

          <Row className="section-first-details__row">
            <Col span={8} className="section-first-details__label">
              Дата окончания работ
            </Col>
            <Col span={16} className="section-first-details__text">
              {fmt(currentItem?.dateEnd)}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
